import script from "./BDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./BDialog.vue?vue&type=script&lang=ts&setup=true"

import "./BDialog.vue?vue&type=style&index=0&id=70d3e75b&lang=scss"

const __exports__ = script;

export default __exports__